/**
 * Authentication and registration of user. Includes cookie management.
 * @author Adrian Rebmann, Eduardo Parducci
 */

/**
 * Globals. Local storage.
 */
import axios from "axios";
import querystring from "querystring";

// Get user messages
var messages = require("./messages.json");

// Get config file name from environment
var environment = process.env.NODE_ENV;
var config = require(`../config/${environment}.json`);

// Emits notifications
var events = require('events');
var eventEmitter = new events.EventEmitter();

const BASE_URL = config.server;

//Content-type headers for HTTP POST requests.
const aconf = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
};

export default {
  /**
   * Event handler for user notification component
   */  
  eventEmitter,

  /**
   * Authenticates login. 
   * @param {*} email - The user's email / username.
   * @param {*} pass  - The user's password.
   */
  login(email, pass) {
    const url = BASE_URL + "/authentication";
    this.logout();
    return axios
      .post(
        url,
        querystring.stringify({ username: email, password: pass }),
        aconf
      )
      .then(res => {
        if (res.data) {
          setCookie("token", res.data.token, 2);
          this.onChange(true);
          } else {
            eventEmitter.emit('Notification', {
              msg: messages.genericFail,
              isError: true
            });
            return res;
          }
        })
      .catch(err => {
        if (err.response.status === 403) {
          eventEmitter.emit('Notification', {
            msg: messages.loginFail,
            isError: true
          });
        } else {
          eventEmitter.emit('Notification', {
            msg: messages.genericFail,
            isError: true
          });
        }
        throw err;
      });
  },
  
  /**
   * Register user to the newsletter.
   * @param {*} email - The user's email / username.
   * @param {*} first - The user's first name.
   * @param {*} last - The user's last name.
   * @param {*} gender - The user's gender.
   */
  registerForNewsletter(email, first, last, gender) {
    const url = BASE_URL + config.user + "/newsletterabo";
    //console.log(email + " " + first + " " + last + " " + gender);
    return axios
      .post(url, {
        username: email,
        firstname: first,
        lastname: last,
        gender: gender
      })
      .then(res => {
        eventEmitter.emit('Notification', {
          msg: messages.genericSuccess,
          isError: true
        });
        return res.data;
      })
      .catch(err => {
        eventEmitter.emit('Notification', {
          msg: messages.genericFail,
          isError: true
        });
        throw err;
      });    
  },

  /**
   * Registration of a user.
   * @param {*} email - The user's email / username.
   * @param {*} pass - The user's password.
   * @param {*} first - The user's first name.
   * @param {*} last - The user's last name.
   * @param {*} gender - The user's gender.
   * @param {*} letter - Register to newsletter?
   * @param {*} cb - Vanilla callback function.
   */
  register(email, pass, first, last, gender, letter, token) {
    const url = BASE_URL + config.user + "/create";
    return axios
      .post(
        url,
        {
          username: email,
          password: pass,
          firstname: first,
          lastname: last,
          gender: gender,
          newsletter: letter,
          recaptchaToken:token
        }
      )
      .then(res => {
        return res.data;
      })
      .catch(err => {
        if(err.response.status===409) {
          eventEmitter.emit('Notification', {
            msg: messages.userCreateDuplicateEmailFail,
            isError: true
          });
        } else {
          eventEmitter.emit('Notification', {
            msg: messages.genericFail,
            isError: true
          });
        }
        throw err;
      });
  },

  /**
   * Get the token from the cookie.
   */
  getToken() {
    return getCookie("token");
  },

  /**
   * Log the user out.
   * @param {*} cb - vanilla callback function.
   */
  logout() {
    setCookie("token", "", 10000);
    //reset cookie:
    setCookie("trainer", false, 10000);
    this.onChange(false);
  },

  /**
   * Check if the user is logged in. 
   */
  loggedIn() {
    //Cast the cookie's token to boolean. 
    //If the token is null, undefined or "", return false. Otherwise return true.  
    return !!getCookie("token");
  },

  /**
   * Check if the user is a trainer.
   */
  isTrainer() {
    return getCookie("trainer")==="true";
  },

  /**
   * Event handler that updates reactive components when login/logout is executed
   */
  onChange() {},

  /**
   * Check if the username exists in the database. 
   * @param {*} username - user's username / email.
   */
  checkUsername(username) {
    const url = BASE_URL + config.user + "/exists/" + username;
    return axios.get(url).then(response => response.data);
  }
};

/**
 * Sets the cookie and its values.
 * @param {*} cname - The cookie's name. 
 * @param {*} cvalue - The cookie's value.
 * @param {*} exhours - The expiration hours.
 */
function setCookie(cname, cvalue, exhours) {
  var d = new Date();
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * 
 * Gets the component of the cookie as stated in the parameter.
 * @param {*} cname - name of the cookie.
 */
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/auth.js